export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return;

  const config = useRuntimeConfig();
  const env = config.public.NUXT_SITE_ENV;
  // Enabled only on production. Disabled on local dev and stage.
  if (env !== "production") return;

  window.dataLayer = window.dataLayer || [];

  // Standard gtag shim — pushes the raw argument list to the dataLayer.
  // Provided as `$gtag` so goal tracking (services/SEO/goals/createCustomGoal.ts)
  // keeps working after the GA4→GTM migration removed the original provider.
  function gtag() {
    window.dataLayer.push(arguments);
  }
  nuxtApp.provide("gtag", gtag);

  if (window.__gtmLoaded) return;
  window.__gtmLoaded = true;

  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-WPMLJH26";
  document.head.appendChild(script);
});
